<nav   class="ops-navbar navbar-default navbar-static-side {{theme}} no-print" role="navigation" [ngClass]="navigationMenuCssClass">
  <div class="sidebar-collapse">
    <ul class="nav metismenu" id="side-menu">

      <li class="menu-display">
        <a class="menu" (click)="toggleNavigation()" style="border-bottom: none;">
          <span tooltip="Menu Display" tooltipPlacement="right">
            <i class="fa fa-fw fa-bars"></i>
          </span>
        </a>

        <div class="logo-container">
            <img class="account-logo" src="./assets/img/product-logos/ops-badge.png">
        </div>
        <h3>{{(currentUser?.fullName)? currentUser.fullName:''}}</h3>
        <p>{{(currentUser?.companyName)? currentUser.companyName: ''}}</p>
      </li>

      <div *ngIf="supplierUser">
        <li [ngClass]="{active: activeRoute('wizard')}" class="navigation-item">
          <a [routerLink]="['wizard/step-1']"><i class="fa fa-user-plus"></i> <span>Invite New Partner</span> </a>
        </li>
        <li [ngClass]="{active: activeRoute('partners')}" class="navigation-item">
          <a [routerLink]="['partners']"><i class="fa fa-users"></i> <span>Partners</span> </a>
        </li>
        <li [ngClass]="{active: activeRoute('invites')}" class="navigation-item">
          <a [routerLink]="['invites/pending']"><i class="fa fa-envelope"></i> <span>Invitations</span> </a>
        </li>
        <ng-container *ngIf="showAccountSettingsLink">
          <li [ngClass]="{active: activeRoute('discount-default')}" class="navigation-item">
            <a [routerLink]="['discount-default']"><i class="fa fa-cog"></i> <span>Account Settings</span> </a>
          </li>
        </ng-container>
      </div>

      <div *ngIf="shopUser">
        <li [ngClass]="{active: activeRoute('shop/partners')}" class="navigation-item">
          <a [routerLink]="['shop/partners']"><i class="fa fa-users"></i> <span>My Partners</span> </a>
        </li>

        <li *appAuthorize="opsFeatures.codes.addRemovePartner" [ngClass]="{active: activeRoute('shop/find-partners')}" class="navigation-item">
          <a [routerLink]="['shop/find-partners']"><i class="fa fa-user-plus"></i> <span>Find Partners</span> </a>
        </li>

        <li *appAuthorize="opsFeatures.codes.setupShopIntegrations" [ngClass]="{active: activeRoute('shop/integrations')}" class="navigation-item">
          <a [routerLink]="['shop/integrations']"><i class="fa fa-gears"></i> <span>Integrations</span> </a>
        </li>
      </div>


    </ul>
  </div>
</nav>
